import type { Shape }           from '@tokamap/core';
import type { LengthUnit }      from '@tokamap/core';
import { distanceMeters }       from '@tokamap/core';
import { formatArea }           from '@tokamap/core';
import { formatDistance }       from '@tokamap/core';
import { polylineLengthMeters } from '@tokamap/core';
import { ringAreaSquareMeters } from '@tokamap/core';
import { ringPerimeterMeters }  from '@tokamap/core';

/**
 * Mesure lisible d'une forme : longueur d'un trait, surface et périmètre d'une forme fermée. Calculée
 * sur les coordonnées géographiques : juste sur un fond réel, et sur un plan importé seulement s'il
 * est posé à sa vraie échelle.
 */
export default function shapeMeasure(shape: Shape, unit: LengthUnit = 'm'): string | undefined {
	const coordinates = shape.coordinates;

	if (shape.shapeKind === 'image' || coordinates.length < 2) return undefined;
	if (shape.shapeKind === 'line') return formatDistance(polylineLengthMeters(coordinates), unit, { compact: true });

	if (shape.shapeKind === 'circle') {
		const radius = distanceMeters(coordinates[0]!, coordinates[1]!);

		return `${formatArea(Math.PI * radius ** 2, unit)} · périmètre ${formatDistance(2 * Math.PI * radius, unit, { compact: true })}`;
	}

	return `${formatArea(ringAreaSquareMeters(coordinates), unit)} · périmètre ${formatDistance(ringPerimeterMeters(coordinates), unit, { compact: true })}`;
}
